import Select, { components } from 'react-select';
import { ArrowPathIcon, PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
export default function InputMultiSelect({
  label,
  error,
  touched,
  labelClassName,
  options = [],
  onReset,
  disabled,
  ...props
}) {
  if (!options?.length) return null;

  return (
    <div className="">
      {label && (
        <label htmlFor={props.name} className={`${labelClassName}`}>
          {label}
        </label>
      )}

      {onReset && props.value && (
        <ArrowPathIcon
          className="w-4 inline-block ml-2 cursor-pointer"
          title="reset"
          onClick={onReset}
        />
      )}

      <Select
        id={props.name}
        styles={{
          control: (base) => ({
            ...base,
            background: '#f6f6f6',
            border: 0,
            boxShadow: 'none',
            padding: '0.5rem 0.5rem',
            borderRadius: '1rem',
            fontSize: '1.25rem',
            color: 'black',
            outline: 'none'
          }),
          option: (base) => ({
            ...base,
            color: 'black',
            fontSize: '1.25rem',
            padding: '0.5rem 0.5rem',
            cursor: 'pointer',
            backgroundColor: '#fff',
            width: 'fit-content',
            borderRadius: '0.25rem'
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: '#f6f6f6',
            padding: 0,
            borderRadius: '1rem',
            width: '98%',
            marginLeft: '1%'
          }),
          menuList: (base) => ({
            ...base,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '0.5rem',
            padding: '1rem'
          })
        }}
        hideSelectedOptions={false}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'gray',
            primary: 'black'
          }
        })}
        isMulti={true}
        className="mb-4"
        options={options}
        blurInputOnSelect={false}
        closeMenuOnSelect={false}
        components={{ Option: CheckboxOption }}
        isDisabled={disabled}
        {...props}
      />
      {error && touched && <p className="text text-red-500">{error}</p>}
    </div>
  );
}
const CheckboxOption = ({ children, isSelected, ...rest }) => {
  return (
    <components.Option {...rest}>
      <div className="flex items-center gap-2">
        {!isSelected && <PlusIcon className="w-4" />}
        {isSelected && <XMarkIcon className="w-4" />}
        <span>{children}</span>
      </div>
    </components.Option>
  );
};
